import png from './images/sharks.png'

export const colors = {
  dominant: '#008ABF',
  highlight: '#fcb53e',
}
export const fullname = 'Sharks'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/sharks.js